import { useCallback, useEffect, useState } from "react";
import { authFetch } from "../../HttpClient";

// Précharge la page 1 (total + items) d'une catégorie du Super Admin pendant
// que la vue d'ensemble est affichée : le skeleton se joue sur la carte, pas
// dans le tableau détaillé, qui reçoit ces données déjà prêtes et s'ouvre
// donc instantanément au clic. Partagé par toutes les catégories (Connexions,
// LM, Événements, et les suivantes) pour éviter de dupliquer ce fetch.
function useCategorySummary({ endpoint, action, pageSize, from, to }) {
  const [data, setData] = useState(null); // { total, items }
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page: "1", pageSize: String(pageSize) });
      if (action) params.set("action", action);
      if (from) params.set("from", from);
      if (to) params.set("to", to);

      const response = await authFetch(
        `https://backend-myalfa.vercel.app/api/super-admin/${endpoint}?${params.toString()}`
      );
      const json = await response.json();
      setData({ total: json.total ?? 0, items: json.items || [] });
    } catch (error) {
      console.error(`Erreur lors de la récupération de ${endpoint} :`, error);
      setData({ total: 0, items: [] });
    } finally {
      setLoading(false);
    }
  }, [endpoint, action, pageSize, from, to]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading };
}

export default useCategorySummary;
